// import { contracts } from "environments/environment"
import * as abi from "../abi/index"


export const CONTRACTS_ABI = (): IContract[] => {
    return [
        { name: eContracts.KMONFT, abi: abi.contractAbiV4Json },
        { name: eContracts.KMONFTV2, abi: abi.contractAbiDiamond },
        { name: eContracts.KMON, abi: abi.tokenAbiJson },
        { name: eContracts.Lottery, abi: abi.lotteryAbiJson },
        { name: eContracts.LotteryOld, abi: abi.lotteryAbiJson },
        { name: eContracts.StakingRewards, abi: abi.stakingRewardsAbiJson },
        { name: eContracts.WBNB, abi: abi.BNBAbi },
        { name: eContracts.WMATIC, abi: abi.BNBAbi },
        { name: eContracts.Lootbox, abi: abi.lootboxAbi },
        { name: eContracts.MarketplaceProxy, abi: abi.marketplaceAbi },
        { name: eContracts.ERC721Bid, abi: abi.ERC721BID },
        { name: eContracts.Playdex, abi: abi.playdexAbi },
        { name: eContracts.PancakeV2, abi: abi.pancakeV2Abi },
        { name: eContracts.StakingRewardsLP, abi: abi.stakingRewardsAbiJson },
        { name: eContracts.StakingRewardsOld, abi: abi.stakingRewardsAbiJson },
        { name: eContracts.LiquidityProvider, abi: abi.pancakeV2Pair },
        { name: eContracts.MerkleBNB, abi: abi.merkleClaimAbi },
        { name: eContracts.AirDropMerkle, abi: abi.merkleAirdrop },
        { name: eContracts.AirDropMerkle2, abi: abi.merkleAirdrop },
        { name: eContracts.BuyMisteryBoxMerkle, abi: abi.merkleClaimAbi },
        { name: eContracts.BUSD, abi: abi.tokenAbiJson },
        { name: eContracts.MerkleMB, abi: abi.merkleMBSaleAbi },
        { name: eContracts.MerkleMBTwo, abi: abi.merkleMBSaleAbi },
        { name: eContracts.MerkleMBThree, abi: abi.merkleMBSaleAbi },
        { name: eContracts.PurchaseTokenMB, abi: abi.tokenAbiJson },
        { name: eContracts.BabyDoge, abi: abi.tokenAbiJson },
        { name: eContracts.USDT, abi: abi.tokenAbiJson },
        { name: eContracts.CCIPSender, abi: abi.CCIPSender },
        { name: eContracts.MerkleEggHunt, abi: abi.merkleClaimAbi },
        { name: eContracts.NFTItems, abi: abi.contractAbiDiamond },
        { name: eContracts.cryptoDotComNft, abi: abi.CryptoDotComNFTAbi }
    ]
}

export enum eContracts {
    KMON = 'KMON',
    KMONFT = 'KMONFT',
    KMONFTV2 = 'KMONFTV2',
    MarketplaceProxy = 'MarketplaceProxy',
    ERC721Bid = 'ERC721Bid',
    Lootbox = 'Lootbox',
    WBNB = 'WBNB',
    BUSD = 'BUSD',
    StakingRewards = 'StakingRewards',
    Lottery = 'Lottery',
    LotteryOld = 'LotteryOld',
    Playdex = 'Playdex',
    PancakeV2 = 'PancakeV2',
    StakingRewardsLP = 'StakingRewardsLP',
    StakingRewardsOld = 'StakingRewardsOld',
    LiquidityProvider = 'LiquidityProvider',//To check if it is still used
    MerkleBNB = 'MerkleBNB',
    MerkleEggHunt = 'MerkleEggHunt',
    AirDropMerkle = 'AirDropMerkle',
    AirDropMerkle2 = 'AirDropMerkle2',
    BuyMisteryBoxMerkle = 'BuyMisteryBoxMerkle',
    MerkleMB = 'MerkleMB',
    MerkleMBTwo = 'MerkleMBTwo',
    MerkleMBThree = 'MerkleMBThree',
    PurchaseTokenMB = 'PurchaseTokenMB',
    BabyDoge = 'BabyDoge',
    USDT = 'USDT',
    CCIPSender = "CCIPSender",
    NFTItems = "NFTItems",
    WMATIC = "WMATIC",
    cryptoDotComNft = "cryptoDotComNft"
}

export interface IContract {
    name: eContracts,
    abi: any
}

export enum eNetworkName {
    bsc = 'bsc',
    // rinkeby = 'rinkeby',
    chapel = 'chapel',
    polygon = 'polygon',
    mumbai = 'mumbai',
    amoy = 'amoy'
}

export const contractAddress: { [key in eNetworkName]: any } = {
    bsc: {
        KMON: "0xc732b6586a93b6b7cf5fed3470808bc74998224d",
        KMONFT: "0xc33d69a337b796a9f0f7588169cd874c3987bde9",
        KMONFTV2: "0x04b0f7d5cb2ce4688497f2525748fb7a9affa394",
        MarketplaceProxy: "0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF",
        ERC721Bid: "0x51EeD96088ED0f6F63C1073d55092bF95a5227fc",
        Lootbox: "0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d",
        WBNB: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        BUSD: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        StakingRewards: "0x65a168cFDA8fECbCBbF197e456099893E7f9094B",
        Lottery: "0x7A16658f04c32D2df40726E3028b600D585D99A5",
        LotteryOld: "0xDDcDF8619d27cBbF12070f3B7cbE5fDe17429622",
        BNFT: "",
        Playdex: "0x959d8d3add23ff8D1F5B37D8db09a95F42f8d904",
        StakingRewardsLP: "0xdBb47Cc765B9656e8C18fa975662CC3EbF778548",
        StakingRewardsOld: "0x16108bcDC5C52a426F823FBF83aBFde763E91ABf",
        LiquidityProvider: "0x9dFf2991f531c44CE5E484bC37589D6A18d68F5E",//To check if it is still used
        MerkleBNB: "0x96eC7E2231d2274a086239916C3b3Dd7CFff91c0",
        MerkleEggHunt: "0xB2b88F03Fc3C170847b3378362E530caCf250EBc",
        AirDropMerkle: "0x3dd9F75965d8D1Ad760A9B849d40560DAf56D76a",
        AirDropMerkle2: "0x3663241F0e84B85a1B58a2254aCfCA5C971f03A5",
        BuyMisteryBoxMerkle: "0xf1f7474E30e72Bf8de26c8A2b67a9d0ebF5FcBFe",
        MerkleMB: "0xaDEBf1d8f86936B81c6CF3078A82773640Fc275D",//check if 0xe308C3C4a4debdf70278Ea628ffF113BdaD0E4B0
        MerkleMBTwo: "0x83305aa200F3932CD3109D2c2AA17c40fE84746A",
        MerkleMBThree: "0x8cE33443A57374B8c6dF24270dd45171acaFA02d",
        BabyDoge: "0xc748673057861a797275CD8A068AbB95A902e8de",
        USDT: "0x55d398326f99059fF775485246999027B3197955",
        PancakeV2: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        NFTItems: "0x04b0f7d5cb2ce4688497f2525748fb7a9affa394",
        CCIPSender: "0xbdA9Cd774Dfc54dB1752b7dD84f4AB1783F47683",
    },
    // rinkeby: {
    //     KMON: "0x20317089818D87df0DE077F02df226bCB4611640",
    //     KMONFT: "0xbc0741f3ec450406bb8dcd24c3eed8549678d868",
    //     KMONFTV2: "0x5ea74a7105f9c2628abe80d3af22afb1d7ce9a46",
    //     MarketplaceProxy: "0x93E0dEBc0552e51Aa97340f8dcE631CEBF32E6Cb",
    //     ERC721Bid: "0xd87AD41E951B08a821A0Bd1BaE91cb6BF36da475",
    //     Lootbox: "0xE9633AEF8e63D75e5d4eF5C7B7D5466544De7DaA",
    //     WBNB: "0x83A7c9C8d5E2A0Ed76EdEe1aB6b2c404DbBeDA87",
    //     BUSD: "0xF1dF161b82e33D4FB27aa7445dE9F4c8Fe273d22",
    //     StakingRewards: "0xb83c69de750d61721ddbf04ba6792e653352047b",
    //     Lottery: "0xc825F037C0957937B8300Ce14662ac559424c44d",
    //     LotteryOld: "",
    //     BNFT: "",
    //     Playdex: "",
    //     StakingRewardsLP: "",
    //     StakingRewardsOld: "",
    //     LiquidityProvider: "",
    //     MerkleBNB: "",
    //     MerkleEggHunt: "0x10c96cB5743E888D320bd245956c6E0C904bD58e",
    //     AirDropMerkle: "0x358A7a85Ace067195bE3A61D1Dc0ae0Ce10F8A24",
    //     AirDropMerkle2: "",
    //     BuyMisteryBoxMerkle: "",
    //     MerkleMB: "0x34746AE9A87A7e42D3f98Ffe46Df8D7D9d79dA4c",
    //     BabyDoge: "",
    //     USDT: ""

    // },
    chapel: {
        KMONFT: "0xe65baf422bb854f71056e6ff3b74e819d77b859f",
        KMONFTV2: "0x0d205d5be22a39a870e0ba00ebe24fc1beeed932",
        KMON: "0xa67375293613b4E081855E605504ba54be6Af139",
        MarketplaceProxy: "0x9bc6d13fdbf796bb19434acf4715fe3396174b77",
        ERC721Bid: "0x7049d2a6369e98660a17505218b78f55f4d70dab",
        Lootbox: "0xe774326fe3caa5805421e10d70040461ee4f57be",
        WBNB: "0x3815b854ed19989736452bad899ed072b16220d1",
        BUSD: "0x250d5fd2ec844a2b238acece2ebb528ec1057693",
        StakingRewards: "0xb50d1db997e0dff09e38a12040b480bf77af13b8",
        Lottery: "0x78ca555c5397719BDFF2ce2f329764ED824e9847", //address in github doc"0x60095C8775a4d1B1e41A92A73Bc7194dC564c347",
        LotteryOld: "",
        BNFT: "0x8bF6404c80863E8bDc176099594Bf949c44c26E4",
        Playdex: "0x6f49b271C1819398Ba75Ca54b333A8cc9F922008",
        StakingRewardsLP: "",
        StakingRewardsOld: "",
        LiquidityProvider: "",
        MerkleBNB: "",
        MerkleEggHunt: "",
        AirDropMerkle: "",
        AirDropMerkle2: "",
        BuyMisteryBoxMerkle: "",
        PancakeV2: "0xdc4904b5f716Ff30d8495e35dC99c109bb5eCf81",
        BabyDoge: "0xFa60D973F7642B748046464e165A65B7323b0DEE", //CAKE in testnet
        MerkleMB: "0x357858f0bFA05053bEf86a92d5a204373502b68F",
        CCIPSender: "0xD2DF37F9fce5De0E38d3677F3A1b5Ba29a4c53bF",
        NFTItems: "0x0d205d5be22a39a870e0ba00ebe24fc1beeed932"
    },
    polygon: {
        KMONFTV2: "0xdfdb045E4300D04EC32058756Ec2453409360C5B",
        MarketplaceProxy: "0x283aCF7670EF9c5419eBE009892310a1D46D6f41",
        KMON: "0x43636e633D037Bd1c87Ae93419076A885cE5b714",
        NFTItems: "0xc08aaaCfC6e589A9a5aE81E3809f3EFB9831510a",
        ERC721Bid: "0xc4170fd71ECed3C80baDca77f4e12E8AaC1e3436",
        Lootbox: "0x5BF2D128de1C31D57587627771B58f0c630187e4",
        WETH: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
        BUSD: "0xdAb529f40E671A1D4bF91361c21bf9f0C9712ab7", //TO CHECK
        USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", //TO CHECK
        BabyDoge: "0xCC3caC22ADb8531834E284B80fC3Fb657689ab72", //TO CHECK
        StakingRewards: "",
        Lottery: "",
        CCIPReceiver: "0xa066aCA36aAbaC13347B49422e2B7338b413CEd3",
        cryptoDotComNft: "0xB9Aba37851DCD3c339Baf58Ebed0d6DE2B0547E6"

    },
    mumbai: {
        KMONFTV2: "0x4604c1eC8104c2aad562e2DD5Bf9D30eE2547F00",
        MarketplaceProxy: "0x61243688f89D19896eFB7DE0f095c20F77E610Ed",
        KMON: "0xaa13799e2552AF270bFC41f85F866b02C7b4D708",
        NFTItems: "0x1213b63d18286dE7F2A805433827F27130D61404", //KMONFT????
        ERC721Bid: "0x671e661d619A0202e16A3Ed5a0D6fEecBf510b4B",
        Lootbox: "0x4F5E2B0C29067e517289BE389405EF2e15020E2C",
        BUSD: "0xA02f6adc7926efeBBd59Fd43A84f4E0c0c91e832",
        USDT: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
        BabyDoge: "0xb59ecDaDaFA3D8A19c2639e5Ee76D31c86110473", //CAKE in testnet TO CHECK
        StakingRewards: "0x5b122591bd67CEb74a0329E3b8972532611a9D43",
        Lottery: "0x067B7d96bff6c924Fd1397535fb9e753861bd952",
        MerkleMB: "0x83305aa200F3932CD3109D2c2AA17c40fE84746A",
        MerkleMBTwo: "0x7398F8D92174f2817444E948cceAf3444324ca5B",
        MerkleMBThree: "0x8cE33443A57374B8c6dF24270dd45171acaFA02d",
        WMATIC: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889",
        CCIPReceiver: "0x704B9450cd79610Ba25703EE3C5bE8b9ad20e063",
        cryptoDotComNft: "0x37a24a44b6FB703050Af2D9B5bdcfCC60C24eF4f"
    },
    amoy: {
        KMON: "0x323b623912F89AC23e3d4bb73AB3F276022E57D4",
        KMONFTV2: "0x75e4377028C1b63F3A8f69808c712Cae3ff04790",
        NFTItems: "0x0D812770cc9453C8C4E5D4Bdc861831bd60A8931",
        CCIPReceiver: "",
        MarketplaceProxy: "0xab44bf29b57BACec0cd64b6994732580e52efdD2",
        ERC721Bid: "0x3eAcE0556e67e764886Eef281E03817b3D2E85B9",
        Lootbox: "0xeA48a3068aFb74a3d68D14ed98B07cfE6978876f",
        WETH: "",
        BUSD: "",
        StakingRewards: "",
        Lottery: ""
    }
}